import React from 'react';
import Select from "@mui/material/Select";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './dropdown.scss'

const  CustomDropdown = React.memo((props) => {

  const { name, value, onChange, list, disableHandleChange } = props
  return (
    <div className="customDropDown">
      <Select
        native={true}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        variant="outlined"
        className='dropdown-select'
        disabled={disableHandleChange}
      >
        {
          list ?
            list.map((el, index) => {
              return (
                <option key={el.value + el.text} value={el.value}>{el.text}</option>
              )
            }) :
            <>
              <option value={0}>Above the text</option>
              <option value={1}>Below the text</option>
            </>
        }

      </Select>
    </div>
  );
})

export default CustomDropdown
